/**
 * VF Cockpit header
 * - "/" focuses search (opens the theme's search modal) unless the shopper is typing somewhere.
 * - Vehicle chip (desktop) and vehicle bar (phone) show the Convermax-selected vehicle and
 *   open the Convermax vehicle dialog on click.
 * - Sets html.vf-hc-vehicle while a vehicle is shown in the header (see sync()).
 */
(function () {
  'use strict';

  function convermaxReady() {
    var c = window.Convermax;
    return !!(
      c &&
      typeof c.isVehicleSelected === 'function' &&
      typeof c.getVehicleString === 'function' &&
      typeof c.openVehicleDialog === 'function'
    );
  }

  function selectedVehicle() {
    try {
      if (convermaxReady() && window.Convermax.isVehicleSelected()) {
        return window.Convermax.getVehicleString() || '';
      }
    } catch (e) {
      /* Convermax mid-init - treat as no vehicle */
    }
    return '';
  }

  function setText(root, selector, text) {
    var el = root.querySelector(selector);
    if (el && el.textContent !== text) el.textContent = text;
  }

  function sync() {
    var vehicle = selectedVehicle();
    var triggers = document.querySelectorAll('[data-vf-hc-vehicle]');
    // Page-level flag: while the header is showing the vehicle, vf_header-cockpit.css strips Convermax's
    // own "<vehicle> PARTS / Change / Clear" card down to a plain heading. On <html> because the theme's
    // DOM morph leaves it alone; only set when the header really rendered, so the stock card stays if not.
    document.documentElement.classList.toggle('vf-hc-vehicle', !!vehicle && triggers.length > 0);
    triggers.forEach(function (el) {
      var isBar = el.classList.contains('vf-hc-vbar');
      // State flag goes on a child: the theme's DOM morph resets attributes on the trigger itself.
      var flagged = el.querySelector('.vf-hc-veh__txt, .vf-hc-vbar__txt') || el;
      if (vehicle) {
        flagged.setAttribute('data-vf-hc-set', '');
        setText(el, '[data-vf-hc-vehicle-name]', vehicle);
        setText(el, '[data-vf-hc-vehicle-sub]', isBar ? 'Showing parts that fit your car' : 'Shopping for');
        setText(el, '[data-vf-hc-vehicle-btn]', 'Change');
      } else {
        flagged.removeAttribute('data-vf-hc-set');
        setText(el, '[data-vf-hc-vehicle-name]', isBar ? 'Add your vehicle' : 'Add vehicle');
        setText(el, '[data-vf-hc-vehicle-sub]', isBar ? 'See only the parts that fit' : 'Your vehicle');
        setText(el, '[data-vf-hc-vehicle-btn]', 'Select');
      }
    });
  }

  var debounceTimer;
  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 120);
  }

  function onVehicleClick(event) {
    var trigger = event.target.closest('[data-vf-hc-vehicle]');
    if (!trigger) return;
    event.preventDefault();
    if (!convermaxReady()) return;
    try {
      window.Convermax.openVehicleDialog();
    } catch (e) {
      /* dialog unavailable - leave page state untouched */
    }
  }

  // Convermax's Clear inside the vehicle dialog only empties the three dropdowns; the selected vehicle stays.
  // With the Cockpit header, Change -> Clear is the way to drop a vehicle on most pages, so make it do that.
  function onDialogClear(event) {
    var clear = event.target.closest('#cm_VehicleWidgetDialog .cm_vehicle-widget_button__clear');
    if (!clear || !selectedVehicle()) return;
    try {
      if (typeof window.Convermax.discardVehicle === 'function') window.Convermax.discardVehicle();
    } catch (e) {
      /* discard unavailable - Convermax's own handler still ran */
    }
    var close = document.querySelector('#cm_VehicleWidgetDialog .close');
    if (close) close.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }

  function isTyping(target) {
    if (!target) return false;
    var tag = target.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
  }

  function onKeydown(event) {
    if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return;
    if (isTyping(event.target)) return;
    var dialog = document.querySelector('#search-modal');
    if (!dialog || typeof dialog.showDialog !== 'function') return;
    event.preventDefault();
    dialog.showDialog();
  }

  function init() {
    document.addEventListener('click', onVehicleClick);
    document.addEventListener('click', onDialogClear);
    document.addEventListener('keydown', onKeydown);

    // The garage widget re-renders whenever the vehicle changes; it is the cheapest change signal.
    var garage = document.getElementById('cm-garage');
    if (garage) new MutationObserver(debouncedSync).observe(garage, { childList: true, subtree: true, attributes: true });

    // Convermax loads asynchronously; poll briefly until its API is up.
    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      if (convermaxReady()) {
        clearInterval(poll);
        sync();
      } else if (attempts > 100) {
        clearInterval(poll);
      }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
